import type { MockSectionCustomerInput } from './mockSectionData.util';
import { mockSectionData } from './mockSectionData.util';
import type { ReportSectionFieldSources } from './reportFieldSource.util';
import { isWarehouseWhoWereReachingSnapshot } from './whoWereReachingSnapshotDetect.util';

const WAREHOUSE_FIELD_SOURCES: ReportSectionFieldSources = {
  costReductionRows: 'warehouse',
  total: 'warehouse',
  summary: 'mock',
};

const MOCK_FIELD_SOURCES: ReportSectionFieldSources = {
  costReductionRows: 'mock',
  total: 'mock',
  summary: 'mock',
};

/**
 * Normalizes closing-value snapshots with `fieldSources` for mock framing.
 * @param snapshot - Stored or live snapshot JSON.
 * @param customer - Customer context for mock fallback fields.
 * @param reportingPeriod - Report period label.
 * @returns Snapshot with `fieldSources` metadata for the Care Portal UI.
 */
export const normalizeClosingValueSnapshot = (
  snapshot: Record<string, unknown>,
  customer: MockSectionCustomerInput,
  reportingPeriod: string,
): Record<string, unknown> => {
  const mockBase = mockSectionData('closing-value', customer, reportingPeriod);
  const isWarehouse = isWarehouseWhoWereReachingSnapshot(snapshot);

  return {
    ...mockBase,
    ...snapshot,
    summary:
      typeof snapshot.summary === 'string' && isWarehouse
        ? snapshot.summary
        : `Removing barriers and engaging members in care drives total cost of care reduction. Per peer-reviewed research, the average annual savings for initiation into BH outpatient care is $2,000 per member, and the average annual savings for a first PCP visit is $4,000 per member. Applied to Reema's ${customer.name} engaged population, the projected savings are below.`,
    fieldSources: isWarehouse ? WAREHOUSE_FIELD_SOURCES : MOCK_FIELD_SOURCES,
    snapshotSource: isWarehouse ? snapshot.snapshotSource : undefined,
  };
};
